export const VF_DEFAULT_QUEUE_FLOW_NAME_REGEX = new RegExp(/^VF_DEFAULT_QFE.*/);
